import router from './router'
import {setStorage,getStorage,removeStorage} from './utils/storageUtil';
const whiteList = ['/login'];// 不重定向白名单
router.beforeEach((to, from, next) => {
    if(to.path ==='/menu1'){
        if(JSON.parse(getStorage("fyToken"))){
            next('/menu2')
        }else {
            next()
        }
    }else {
        next()
    }
    // if (window.getUser().token) {
    //     if(to.matched.length){
    //         next()
    //     }else{
    //         next('/404')
    //     }
    //
    // } else {
    //     if (`${to.path}`.indexOf('login') === -1 && !getWhiteItem(whiteList, to.path)) {
    //         next('/login')
    //     } else {
    //         next()
    //     }
    // }
});

router.afterEach(() => {

});

//判断path是否在白名单内
function getWhiteItem(whiteList, path) {
    let srcPaths = path.split("/");
    let isWhite = false;
    whiteList.forEach(e => {
        if (!isWhite) {
            let paths = e.split("/");
            if (paths[paths.length - 1] === "*") {
                let containsPath = true;
                for (let i = 0; i < paths.length - 1; i++) {
                    if (paths[i] !== srcPaths[i]) {
                        containsPath = false;
                        break;
                    }
                }
                isWhite = containsPath;
            } else {
                if (e === path) {
                    isWhite = true;
                }
            }
        }
    });
    return isWhite;
}
